export class FilterPrintSortiesProductionDTO {
  showNumeroLot: boolean;
  showDlc: boolean;
  showQteTotaleUS: boolean;
  showCommentaire: boolean;
  selectedIds: number[];
  disablePageBreak: boolean;
  disableQuantityZero: boolean;
}
